import React from 'react'
import Page from '../../components/layout/Page'
import Icon from '../../components/AppIcon'
import OfficeWorkspaceShell from '../../components/layout/OfficeWorkspaceShell'

const JobsManagement = () => {
  return (
    <Page
      size="full"
      title="Jobs"
      subtitle="Job tracking and scheduling"
    >
      <OfficeWorkspaceShell
        activeSectionId="jobs"
        activeSectionLabel="Jobs"
        activeSectionIcon="CalendarDays"
        activeSectionDescription="Job tracking and scheduling"
        operations={[]}
        workspaces={[]}
        operationsTitle="Menu"
        compactMenu
        layoutPreset="office"
      >
        <div className="bg-card rounded-2xl border border-border p-10 sm:p-16 text-center">
          <div className="w-16 h-16 rounded-2xl bg-warning/15 border border-warning/20 flex items-center justify-center text-warning mx-auto mb-6">
            <Icon name="CalendarDays" size={30} />
          </div>
          <span className="inline-block px-3 py-1 rounded-full bg-warning/15 border border-warning/20 text-xs font-semibold uppercase tracking-wide text-warning mb-4">
            Coming Soon
          </span>
          <h2 className="text-xl font-semibold text-foreground">A new Jobs experience is on the way</h2>
          <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">
            Your assigned jobs and products will appear here when this workspace is available.
          </p>
        </div>
      </OfficeWorkspaceShell>
    </Page>
  )
}

export default JobsManagement
